<template>
  <div class="dashboard-greeting mb-4">
    <h2 class="text-h5 font-weight-bold mb-1 secondary--text">
      Hello {{ userName }},
    </h2>
    <p class="text-body-2 mb-0 grey--text text--darken-1">
      {{ date }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'DashboardGreeting',

  props: {
    userName: {
      type: String,
      default: 'there',
    },
    date: {
      type: String,
      required: true,
    },
  },
};
</script>
